module.exports = __webpack_public_path__ + "img/Solution2.e78f0da9.png";